module.exports = __webpack_public_path__ + "media/images/emoticons/heart02-0cf8727d80cfccfa333bd2c6c00a3b6a.gif";